import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PageContainer = styled.div`
  min-height: 100vh;
  background: black;
  color: white;
  display: flex;
  flex-direction: column;
`;

const ContentContainer = styled.div`
  flex: 1;
  padding: 80px 5% 40px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
`;

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 2rem;
  text-align: center;
  color: white;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  text-align: center;
  max-width: 800px;
  margin: 0 auto 4rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
`;

const PlatformGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const PlatformCard = styled(Link)`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 2rem;
  text-decoration: none;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
  }
  
  h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  
  p {
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
  }
`;

function Platform() {
  const platforms = [
    {
      title: "Airfield Operations",
      description: "Advanced air traffic management and ground operations optimization for modern airfields.",
      link: "/platform/airfield-operations"
    },
    {
      title: "Maritime Operations",
      description: "Comprehensive maritime domain awareness and vessel traffic management solutions.",
      link: "/platform/maritime-operations"
    },
    {
      title: "Logistics Operations",
      description: "End-to-end logistics optimization and supply chain intelligence platform.",
      link: "/platform/logistics-operations"
    }
  ];

  return (
    <PageContainer>
      <Navbar />
      <ContentContainer>
        <Title>Platform</Title>
        <Subtitle>
          Explore our comprehensive suite of operational solutions designed to transform and automate complex geospatial operations across multiple domains.
        </Subtitle>
        
        <PlatformGrid>
          {platforms.map((platform, index) => (
            <PlatformCard to={platform.link} key={index}>
              <h2>{platform.title}</h2>
              <p>{platform.description}</p>
            </PlatformCard>
          ))}
        </PlatformGrid>
      </ContentContainer>
      <Footer />
    </PageContainer>
  );
}

export default Platform; 